export default __webpack_public_path__ + "static/david-headshot-76bc2842e8c0720abd88335355c6455f.png";